import './conversatorio.css'
import SubHeading from '../../../subHeading/SubHeading'
import cartelImg from '../../../../assets/img/adriana-guzman.png'

export default function Conversatorio() {
  return (
    <section className='conversatorio'>
      <div className='conversatorio__wrapper'>
        <SubHeading title='Conversatorio' />
        <div className='conversatorio__container'>
          <div className='conversatorio__image'>
            <img src={cartelImg} alt='Conversatorio con Adriana Guzmán - Cartel' />
          </div>
          <div className='conversatorio__content'>
          <h3 className='conversatorio__speaker'>Con Adriana Guzmán Arroyo</h3>
          
          <div className='conversatorio__date-location'>
            <p className='conversatorio__date'>📅 Lunes 25 de mayo</p>
            <p className='conversatorio__note'>(revisa tu zona horaria en el cartel)</p>
          </div>

          <div className='conversatorio__description'>
            <p>El lunes 25 de mayo, en el marco del Día Internacional de la Salud Menstrual (28M), nos encontraremos online en conversatorio con Adriana Guzmán Arroyo, aymara, lesbiana, feminista, educadora popular y abogada; integrante de Feminismo Comunitario Antipatriarcal y de Feministas de Abya Yala, autora del libro <em>Descolonizar la memoria, descolonizar feminismos</em>.</p>

            <p>Un conversatorio para pensar juntas la menstruación, la ciclicidad, el útero, el cuerpo y el territorio, a partir de las experiencias y debates de las compañeras de Bolivia y del libro <em>Educación Menstrual</em>. Un libro colectivo desde el sentipensar, la experiencia y la investigación científica, en clave feminista, interseccional e internacional, una obra escrita entre catorce autoras.</p>
          </div>

          <div className='conversatorio__details'>
            <div className='conversatorio__detail-item'>
              <span className='conversatorio__detail-icon'>📍</span>
              <p>Conversatorio vía Zoom</p>
            </div>
            <div className='conversatorio__detail-item'>
              <span className='conversatorio__detail-icon'>⏱️</span>
              <p>Duración: 90 minutos</p>
            </div>
            <div className='conversatorio__detail-item'>
              <span className='conversatorio__detail-icon'>🎥</span>
              <p>Acceso solo en directo. Será grabado, pero la grabación no será compartida</p>
            </div>
            <div className='conversatorio__detail-item'>
              <span className='conversatorio__detail-icon'>✍️</span>
              <p>Inscripción previa para recibir el enlace</p>
            </div>
          </div>

          <p className='conversatorio__final-text'>Las coautoras del libro agrupadas como <strong>'Red Internacional de Educación Menstrual'</strong> estamos preparando este valioso evento internacional y accesible online. Te esperamos para seguir tejiendo pensamiento colectivo en torno a la sangre, los cuerpos y la vida.</p>

          <a 
            href='https://4bd89425.sibforms.com/serve/MUIFAILOkQ67QAqMW_4sQJObdtRBmrAgC5I7xm38C34c89n_vphgRk_2ihTbzPgN4UY_YaNrT_IRqaPn9b9zNA2bhrs4eiPN7HsF4WkDUqClZkx4mmpEZFufQwhxeLSsC0s7jLGl99qq1sVg0izqxzYhNgvM1JvbfP1OPFeG6fMeh6H6loeVkfhm6BevWeib2FmipSBufHtsR5HO'
            className='conversatorio__button'
            target='_blank'
            rel='noopener noreferrer'
          >
            Apuntarme al conversatorio
          </a>
          </div>
        </div>
      </div>
    </section>
  )
}
